import { useStore } from 'zustand'
import { getAuthStore, type AuthState } from './store-core.ts'

export * from './store-core.ts'

/** Zustand hook — use inside React components. */
export function useAuthStore(): AuthState
export function useAuthStore<T>(selector: (state: AuthState) => T): T
export function useAuthStore<T>(selector?: (state: AuthState) => T) {
  return useStore(getAuthStore(), selector as (state: AuthState) => T)
}
